const item = Object.freeze({
  SpecialEducation: 1,
  Infraestructure: 2,
  ProvisionalRemedy: 3,
  Transportation: 4,
  ProfessionalServices: 5,
  OMEP: 6,
  Occ: 7,
});

export default item;
